import { createBuilderModule } from '../../builder';
import { HubSpotFormV2 } from '.';
import { COLOR_KEYS_LIST } from '../../constants';

export default createBuilderModule(HubSpotFormV2, {
  name: 'HubSpotFormV2',
  image: 'https://cdn.zappy.app/65aca327f8d8f58911a8564e9ab0500d.png',
  inputs: [
    {
      name: 'title',
      type: 'string',
    },
    {
      name: 'description',
      type: 'richText',
    },
    {
      name: 'account',
      type: 'string',
      enum: ['zapier', 'sandbox'],
      required: true,
      defaultValue: 'zapier',
    },
    {
      name: 'formId',
      friendlyName: 'Form ID',
      type: 'string',
      required: true,
    },
    {
      name: 'prefilledFields',
      helperText:
        'Use to have any fields prefilled when the form loads. This can also be used for hidden fields. https://legacydocs.hubspot.com/docs/methods/forms/advanced_form_options',
      type: 'list',
      subFields: [
        {
          friendlyName: 'Field name / contact property',
          helperText:
            'The contact property in Hubspot, which is also the "name" property of the HTML input (https://cdn.zappy.app/203ef02c90c194e3c4c1ae36d7636a00.png)',
          name: 'name',
          required: true,
          type: 'string',
        },
        {
          friendlyName: 'Field value',
          helperText:
            'The value that you would like to pre-populate in the field; if the field type is a checkbox, then input either "true" or "false"; if the field type is a checkbox group, then provide the prefilled values as a comma-separated list',
          name: 'value',
          type: 'string',
        },
        {
          name: 'cookieToBind',
          type: 'string',
          helperText:
            'The name of the cookie to bind the prefilled value to (used in place of the "Field value" input above)',
        },
        {
          friendlyName: 'Hide if prefilled',
          helperText: 'The option to hide a field that has been prefilled',
          name: 'isHiddenIfPrefilled',
          type: 'boolean',
        },
      ],
    },
    {
      name: 'submitButtonColor',
      type: 'string',
      enum: ['primary', 'primary-alt'],
    },
    {
      name: 'backgroundColor',
      type: 'string',
      enum: COLOR_KEYS_LIST,
    },
    {
      name: 'disableSpacing',
      type: 'boolean',
    },
    {
      name: 'enableChiliPiper',
      friendlyName: 'Enable Chili Piper',
      type: 'boolean',
    },
    {
      name: 'chiliPiperRouter',
      friendlyName: 'Chili Piper router',
      type: 'string',
      helperText: 'The ID of the inbound router in Chili Piper',
      showIf(options) {
        return !!options.get('enableChiliPiper');
      },
    },
  ],
});
